import React, { useState, useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import classnames from 'classnames';

import styles from './BulkImport.module.scss';
import BulkImportModal from './BulkImportModal/BulkImportModal';
import { BulkImportType } from './BulkImportModal/formSteps/FileSelection/hooks';

const DrmPageRegex = {
  DATA_VENDOR: /^\/data-providers(\/|$)/,
  CONTACT: /^\/contacts(\/|$)/,
  DATASET: /^\/data-sets(\/|$)/,
};

const DrmPageToRegex: Array<[RegExp, BulkImportType]> = [
  [DrmPageRegex.DATA_VENDOR, BulkImportType.DATA_VENDOR],
  [DrmPageRegex.CONTACT, BulkImportType.CONTACT],
  [DrmPageRegex.DATASET, BulkImportType.DATASET],
];

const getDrmPage = (pathname: string): BulkImportType | null => {
  for (const [regex, drmPage] of DrmPageToRegex) {
    if (regex.test(pathname)) {
      return drmPage;
    }
  }

  return null;
};

const BulkImport = () => {
  const { pathname } = useLocation();
  const [showBulkImportModal, setShowBulkImportModal] = useState(false);

  const drmPage = useMemo(() => {
    return getDrmPage(pathname);
  }, [pathname]);

  if (!drmPage) {
    return null;
  }

  return (
    <>
      <Button
        type="button"
        className={classnames(styles.btnSecondary)}
        variant="secondary"
        size="sm"
        onClick={() => setShowBulkImportModal(true)}
      >
        BULK IMPORT
      </Button>
      {showBulkImportModal && (
        <BulkImportModal
          defaultBulkImportType={drmPage}
          onClose={() => setShowBulkImportModal(false)}
        />
      )}
    </>
  );
};

export default BulkImport;
